import React from 'react';
import { Button, Sym } from '../../../components/app2';

/**
 * Barra de acciones masivas de administradores de empresa (rediseño jul-2026).
 *
 * Gemela de la de Super Admins: aparece SOLO cuando hay selección. Antes era una
 * tarjeta permanente con un "Seleccionar Todos" que ahora vive en la cabecera de
 * la tabla y un recuadro de ayuda que repetía lo evidente; el alta subió al
 * encabezado de la pantalla.
 */
const AdminActionsToolbar = ({ selectedCount = 0, onBulkDelete, onClearSelection }) => {
  if (!selectedCount) return null;

  const plural = selectedCount !== 1;

  return (
    <div
      className="a2-anim-fadein"
      style={{
        display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 10,
        padding: '12px 20px', borderBottom: '1px solid var(--line)',
        background: 'var(--brand-soft)',
      }}
    >
      <Sym name="checklist" size={20} style={{ color: 'var(--brand-2)' }} />
      <span style={{ font: "600 .88rem 'Hanken Grotesk'", color: 'var(--heading)' }}>
        {selectedCount} administrador{plural ? 'es' : ''} seleccionado{plural ? 's' : ''}
      </span>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginLeft: 'auto' }}>
        <Button variant="ghost" size="sm" icon="close" onClick={onClearSelection}>
          Quitar selección
        </Button>
        <Button variant="danger" size="sm" icon="delete" onClick={onBulkDelete}>
          Eliminar seleccionado{plural ? 's' : ''}
        </Button>
      </div>
    </div>
  );
};

export default AdminActionsToolbar;
